import { Injectable } from '@angular/core';
import {
  DailyLogOperationInstance,
  DailyLogType,
  DailyOperationLogRecord
} from '../../../models/projects/operation.models';
import { DailyLogService } from '../daily-log.service';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { TimeZoneService } from '../../time-zone/time-zone.service';
import { TimeZoneChangeEditor } from '../../../models/time-zones/time-zone.models';

@Injectable()
export class DateChangeRecordService {

  constructor(
    private dailyLogService: DailyLogService,
  ) {
  }

  async removeTypeOfRecord(date: PtLuxonDate, type: DailyLogType) {
    const data = await this.dailyLogService.getDailyLogDataForDay(date);
    const dailyLogData = data.records;

    const dateChangeRecord = dailyLogData.find(e => e.typeId === type);

    if (dateChangeRecord) {
      this.dailyLogService.deleteDailyLogRecord(dateChangeRecord.id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/daily-log/date-change-record/date-change-record.service.ts